<template>
  <div>
    <justificatif-table :tableEntry="tableParam" ref="justificatif_beneficiaire" :statusTab="status"></justificatif-table>
  </div>  
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '../utils/auth'
import JustificatifTable from './JustificatifBeneficiaireTable'

export default {
  props: ['benefId'],
  components: { JustificatifTable },
  data() {
    let self = this;
    return {
      status: []
    }
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common['Authorization'] = getIdToken() + ' ' + getAccessToken()
    this.$axios.defaults.headers.common['Accept'] = 'application/json'
    this.$axios.defaults.headers.common['Provider'] = getProvider()

    this.getJustificatifStatus()
  },
  mounted() {
    // this.$refs.justificatif_beneficiaire.$refs.table.refresh()
  },
  computed: {
    tableParam: {
      get() {
        let request = {}
        request.benefId = this.benefId
        return request
      }
    },
  },
  methods: {
    getJustificatifStatus() {
      let self = this
      this.$axios.get('/espaceBeneficiaire/beneficiaires/justificatifs/status')
        .then((response) => {
          this.status = response.data.status
        }).catch(function (error) {
          let errorText = 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support'
          if (error.response && error.response.status === 401 && self !== undefined) {
            errorText = 'Accès non autorisé.'
          }
          self.$swal(
            {
              position: 'top', type: 'error', title: 'Attention !!', text: errorText, showConfirmButton: false, timer: 5000
            })
        })
    }
  }
}
</script>

<style>

</style>
